<template>
  <div id="premiumconfirmation">
    <v-layout row wrap>
      <v-flex xs1>
        <v-btn small icon dark @click="close()">
          <v-icon color="primary">arrow_back</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs11 class="caption404">
        <span style="color:#355EAB; font-size:18px;">Halaman Tidak Ditemukan</span>
      </v-flex>
    </v-layout>
    <v-container text-xs-center class="pt-5">
      <v-layout row wrap>
        <v-flex xs12>
          <p>
            <span style="color:#355EAB; font-size:30px;font-weight:bold;">
            404
          </span>
          </p>

        </v-flex>
        <v-flex xs12>
          <p>
            Halaman yang kamu maksud keliru. Ayo Kembali ke halaman awal
          </p>
          <v-btn flat color="primary" @click="close()">
              Kembali
          </v-btn>

        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<style>
.caption404 {
  letter-spacing: 0.02em;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; display:flex; align-items:center;
}
</style>
<script>

/* eslint-disable */
export default {
  name: 'coming-soon',
  data() {
    return{
      show: true
    }
  },
  methods: {
    close() {
        this.$router.push('/')
    },
  }
}
</script>
